import React from "react";
import { Box, Grid, Paper } from "@material-ui/core";
import { AdminLayout } from "frontend/src/pages/layouts";
import { ClientUserAccount } from "./client-user-account";
import { useLoadClient, usePageModel } from "./model";
import { ClientLegalEntity } from "./client-legal-entity";
import { ClientEmployees } from "./client-employees";
import { ClientInvoices } from "./client-invoices";
import { ClientCabinetSettings } from "./client-cabinet-settings";
import { ClientSites } from "./client-sites";
import { ClientActivityLogs } from "./client-activity-logs";
var Page = function () {
    var clientId = usePageModel();
    return (React.createElement(Box, null,
        React.createElement(Grid, { container: true, spacing: 1, alignItems: "stretch" },
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(ClientUserAccount, { clientId: clientId })),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(ClientLegalEntity, { clientId: clientId }))),
        React.createElement(Box, { component: Paper, p: 2, mt: 1 },
            React.createElement(ClientEmployees, { clientId: clientId })),
        React.createElement(Box, { mt: 1 },
            React.createElement(ClientCabinetSettings, { clientId: clientId })),
        React.createElement(Box, { mt: 1 },
            React.createElement(ClientSites, { clientId: clientId })),
        React.createElement(Box, { component: Paper, mt: 1 },
            React.createElement(ClientInvoices, { clientId: clientId })),
        React.createElement(Box, { mt: 1 },
            React.createElement(ClientActivityLogs, { clientId: clientId }))));
};
export var ViewClientPage = function () {
    useLoadClient();
    return (React.createElement(AdminLayout, null,
        React.createElement(Page, null)));
};
